/*EndPoint para enviar el formulario de contacto*/
export const SEND_FORM_CONTACT = "/Norma035/Dashboard/enviaContacto"

export const SEND_INSERT_COMPANY = "/Norma035/Dashboard/insertEmpTemp"

export const SEND_ACEPT_CONTRACT = "/Norma035/Dashboard/aceptarContrato"

export const SEND_PAYMENT = "/Norma035/Dashboard/actualizarPago"

export const DELETE_COMPANY = "/Norma035/Dashboard/elimEmpTemp"